import CertificateImage from "../../../CertificateImage";
import CertificateInfo, { ListInfoProps } from "@/components/BulletListInfo";

import { defaultTabCertificateInfoData } from "../../../constants/certitificateInfo";

export default function CertificateInfoTab({
  externalData,
}: {
  externalData?: ListInfoProps;
}) {
  return (
    <>
      <CertificateInfo
        title={externalData?.title ?? defaultTabCertificateInfoData.title}
        details={externalData?.details ?? defaultTabCertificateInfoData.details}
      />
      <CertificateImage />
    </>
  );
}
